import { COLORS } from "layouts/ThemeProvider/palette";

export default {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        backgroundColor: "#fff",
        color: COLORS.havelockBlue,
      },
      a: {
        textDecoration: "none",
        color: COLORS.havelockBlue,
      },
      "input, textarea, button": {
        fontFamily: "inherit",
        fontSize: "inherit",
        fontWeight: "inherit",
      },
    },
  },
};
